type mediaSummaryData = {
  typeProperties: any;
  medias: any;
};

export const ShopMediaSummary: React.FunctionComponent<{
  mediaSummary: mediaSummaryData;
}> = (props) => {
  return <div>{/* TODO: preview */}</div>;
};
